import { TransformRule, TransformRuleData } from "./TransformRule";

export { ReplaceDate, ReplaceDateData };

type ReplaceDateData = {
  targetFormat: string;
  inputDateFormat: string;
} & TransformRuleData;

class ReplaceDate extends TransformRule {
  targetFormat: string;
  inputDateFormat: string;

  constructor(data: ReplaceDateData) {
    super(data);
    this.targetFormat = data.targetFormat;
    this.inputDateFormat = data.inputDateFormat;
  }

  getDlfVariables() {
    return [];
  }

  getVariables() {
    return [];
  }

  isConfigured(): boolean {
    return this.targetFormat.length > 0;
  }

  getRuleId(): string {
    return `${this.getDiscriminator()}-${this.fieldName}-${this.position}-${this.targetFormat}-${this.inputDateFormat}`;
  }

  toData(): ReplaceDateData {
    return {
      discriminator: this.discriminator,
      fieldName: this.fieldName,
      position: this.position,
      targetFormat: this.targetFormat,
      inputDateFormat: this.inputDateFormat,
    };
  }

  static createTest(rest: Partial<ReplaceDateData> = {}): ReplaceDate {
    const data: ReplaceDateData = {
      discriminator: "T_REPDATE",
      fieldName: "",
      position: 0,
      targetFormat: "",
      inputDateFormat: "",
    };

    return new ReplaceDate({
      ...data,
      ...rest,
    });
  }
}
